<template>
  <label class="type-checkbox-pill">
    <input
      type="checkbox"
      v-model="current"
      :required="required"
      :data-parsley-required-message="requiredMessage ? requiredMessage : false"
      :disabled="disabled"
      @input="current = !current"
      @click="$emit('click', $event.target.checked)"
    />
    <span class="label"><span v-html="label"></span></span>
  </label>
</template>

<script>
export default {
  props: {
    inputValue: {
      default: true,
    },
    label: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    requiredMessage: {
      type: String,
    },
    value: {
      required: true,
    },
    checked: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    isBoolean: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mounted() {
    if (this.checked) {
      this.current = true;
    }
  },
  data() {
    const selected = Array.isArray(this.value)
      ? this.value.includes(this.inputValue)
      : Boolean(this.value);

    return {
      current: selected,
    };
  },
  watch: {
    current(now, was) {
      if (Array.isArray(this.value)) {
        let result = [...this.value];

        if (this.current && !this.value.includes(this.inputValue)) {
          result.push(this.inputValue);
        } else if (!this.current) {
          let index;
          do {
            index = result.indexOf(this.inputValue);
            if (index !== -1) {
              result.splice(index, 1);
            }
          } while (index !== -1);
        }

        return this.$emit("input", result);
      }

      this.$emit(
        "input",
        this.current ? this.inputValue : this.isBoolean ? false : null
      );
    },
    value() {
      this.current = Array.isArray(this.value)
        ? this.value.includes(this.inputValue)
        : Boolean(this.value);
    },
  },
};
</script>